import { Banner, Modal, Toast } from 'shared/ui'
import { APP_TYPE } from 'shared/config'
import { GlobalEvents } from 'entities/WebSocket'
import { IdleManager } from 'entities/Auth/ui/IdleManager'
import { PresentationMode } from 'widgets/PresentationMode/ui/PresentationMode'
import { CallPopUp } from 'widgets/CallPopUp'
import { GlobalBanners } from 'widgets/GlobalBanners/GlobalBanners'
import { RetentlyLayout } from './RetentlyLayout'

export const CommonLayout = () => {
  const onlyForReactApp = APP_TYPE === 'react' || APP_TYPE === 'light'
  const isVueApp = APP_TYPE === 'vue'

  return (
    <>
      {!isVueApp && <GlobalEvents />}
      <Toast />
      <PresentationMode />
      <RetentlyLayout />
      {!isVueApp && <IdleManager />}
      {onlyForReactApp && (
        <>
          <Banner globalBanners={<GlobalBanners />} />
          <Modal />
          <CallPopUp />
        </>
      )}
    </>
  )
}
